import { SOURCE_LABELS, STATUS_OPTIONS, PAYMENT_METHOD_OPTIONS, RECORD_STATE_OPTIONS } from "./constants";

const RECORD_TYPE_LABELS = { "": "All Records", Weekly: "Weekly", Monthly: "Monthly" };

export function getFilterLabel(key, value) {
  if (value == null || value === "") return value;
  if (key === "recordType") return RECORD_TYPE_LABELS[value] || value;
  if (key === "source") return SOURCE_LABELS[value] || value;
  if (key === "record_state") return (RECORD_STATE_OPTIONS.find((o) => o.value === value) || {}).name || value;
  if (key === "payment_method") return (PAYMENT_METHOD_OPTIONS.find((o) => o.value === value) || {}).name || value;
  if (key === "status") return (STATUS_OPTIONS.find((o) => o.value === value) || {}).name || value;
  if (key === "emailType") return value === "naseebimail" ? "Naseebi Mail" : value === "other" ? "Other" : value;
  if (key === "date_from" || key === "date_to") {
    return value
      ? new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : value;
  }
  return value;
}
